<template>
  <div>

    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DETAIL OF' : (Object.entries(this.data).length === 0 ? "NEW" : "CHANGE THE ") }} PAGE</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2" v-if="!detail__detail">
              <p class="mt-5" >User name <b style="color: #ff6141">*</b> </p>
              <vs-input v-model="input.username" class="w-full" name="item-username" />
              
              <p class="mt-5" >Email <b style="color: #ff6141">*</b> </p>
              <vs-input v-model="input.email" class="w-full" name="item-email" />

              <p class="mt-5" >Password <b style="color: #ff6141">*</b> </p>
              <vs-input v-model="input.password" type="password" class="w-full" name="item-password" />
              
              <p class="mt-5" >Rôle <b style="color: #ff6141">*</b> </p>
              <v-select
                :options="groupss"
                :reduce="(rep) => rep.id"
                :clearable="true"
                label="libelle"
                v-model="input.group_id"
                class="w-full"
              />

              <div>
                <h4 class="text-danger" v-for="(item, index) in loginError.array" :key="index">
                  {{ loginError.object[item] }}
                </h4>
              </div>
            </div>

        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitDataSimple">Submit</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </div>
    </vs-sidebar>
  </div>
</template>

<script>
let base_self = ''
const input_tempon = {
  username: '',
  email: '',
  password: '',
  group_id: ''
}

// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {VuePerfectScrollbar, Treeselect},
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loginError: {
        object: {},
        array: []
      },
      groupss: [],
      general: {},
      object_options: {},
      object: {},
      value: [],
      options: [],
      label: ['libelle', 'libelle'],
      fonctionnalites: [],
      initialNoError: {
        libelle: false,
        wording: false
      },
      error: {
        libelle: false,
        wording: false
      },
      all_errors: {
        libelle: [],
        wording: []
      },
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      let is_valide = true
      if (!this.input.libelle || this.input.libelle === '') is_valide = false
      return is_valide
    }
  },
  methods: {
    async getGroupss () {
      const param = { is_get: true }

      base_self.$http.post(`${base_self.$store.state.route_for_account}groups`, param)
        .then((response) => {
          base_self.groupss = response.data.data

          console.log('base_self.groupss: ', base_self.groupss)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    async submitDataSimple () {
      base_self.$vs.loading()
      const input = JSON.parse(JSON.stringify(base_self.input))

      if (!input.id) {     
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Register/ProfileUtilisateur`, input)
          .then((response) => { 
            console.log('The users is added successfully.', response.data.id)
            console.log(' ................... The users is added successfully ................... ')
            base_self.$vs.loading.close()
            window.getESM.success('The users is added successfully.', response)
            window.getAppMasters.getMasters()
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => {  
            base_self.$vs.loading.close()
            console.log('error: ', error)

            base_self.loginError.object = error.response.data
            base_self.loginError.array = Object.keys(error.response.data)
          })

      } else if (input.id) {
        base_self.$http.put(`${base_self.$store.state.route_for_esm}Register/ProfileUtilisateur`, input)
          .then((response) => {  
            console.log('The users is changed successfully.', response)
            console.log(' ................... The users is changed successfully ................... ')
            base_self.$vs.loading.close()
            window.getESM.success('The users is changed successfully.', response)
            window.getAppMasters.getMasters()
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => {  
            base_self.$vs.loading.close()
            console.log('error: ', error)
          })
      }
    },
    initValues () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon))
      base_self.value = []
      
      base_self.detail__detail = false
    }
  },
  watch: {
    async isSidebarActive () {
      base_self.initValues()
      console.log('base_self.data: ', base_self.data)
      base_self.input.id = base_self.data.id
      base_self.input.username = base_self.data.username
      base_self.input.email = base_self.data.email
      base_self.input.group_id = base_self.data.group.id

      if (base_self.data.detail__detail) {
        base_self.detail__detail = true
      }
    }
  },
  created () {
    base_self = this
    base_self.initValues()
    base_self.getGroupss()
  }
}

</script>

<style>
/* .vue-treeselect__multi-value-item {
    display: inline-table;
    color: #e50303;
    font-size: 12px;
    vertical-align: top;
}  */

.vue-treeselect__multi-value-item {
    display: inline-table;
    color: #ffffff;
    font-size: 12px;
    vertical-align: top;
}

[dir] .vue-treeselect__multi-value-item {
    cursor: pointer;
    background: #FF8000;
    padding: 2px 0;
    border: 1px solid transparent;
    border-radius: 2px;
}

.vue-treeselect__value-remove {
    color: #ffffff;
    line-height: 0;
}

/* ------------------------------------------------------------------------------------------- */

.vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control {
  border-color: #FF8000;
  box-shadow: 0 0 0 3px rgba(3, 155, 229, 0.1);
}

.vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-disabled):hover .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new):hover {
  color: #FF8000;
}

.vue-treeselect__label-container:hover .vue-treeselect__checkbox--unchecked {
  border-color: #FF8000;
}
.vue-treeselect__checkbox--indeterminate {
  border-color: #FF8000;
  background: #FF8000;
}
.vue-treeselect__label-container:hover .vue-treeselect__checkbox--indeterminate {
  border-color: #FF8000;
  background: #FF8000;
}
.vue-treeselect__checkbox--checked {
  border-color: #FF8000;
  background: #FF8000;
}
.vue-treeselect__label-container:hover .vue-treeselect__checkbox--checked {
  border-color: #FF8000;
  background: #FF8000;
}

.vue-treeselect__error-tip .vue-treeselect__retry {
  color: #FF8000;
}

.vue-treeselect__icon-loader::before {
  background: #FF8000;
}

</style>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>